import { render } from "./LanguageSwitcher.vue?vue&type=template&id=b81e4e7e&scoped=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=b81e4e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81e4e7e"]])

export default __exports__